import { proxy } from 'valtio';

export enum TTEditorModeEnum {
  EDIT = 'EDIT',
  PREVIEW = 'PREVIEW',
  LEARNER = 'LEARNER',
  ASSESSOR = 'ASSESSOR',
}

export enum EditorSavingStateEnum {
  UNSAVED_CHANGES = 'UNSAVED_CHANGES',
  SAVED = 'SAVED',
  SAVING = 'SAVING',
}

export const dukeTTEditorState = proxy({
  mode: TTEditorModeEnum.EDIT,
  state: EditorSavingStateEnum.SAVED,
});
